<template>
  <div class="edit_page">
    <div class="page-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      <div class="title">修改客户信息</div>
    </div>
    <el-form ref="form" :model="form" label-width="55px" :rules="rules" status-icon v-loading="loading" :validate-on-rule-change="false">

      <el-form-item label="来源" prop="origin_type">
        <el-radio-group v-model="form.origin_type">
          <template v-for="item of originTypes">
            <el-radio :key="item.id" :label="item.value" border>{{ item.name }}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>

      <template v-if="form.origin_type === 'online'">
        <el-form-item label="搜索">
          <el-input v-model="form.origin_words" placeholder="选填,客户搜索来源词"></el-input>
        </el-form-item>

        <el-form-item label="站点">
          <el-radio-group v-model="form.origin_site">
            <template v-for="site in originSites">
              <el-radio-button :key="site.id" :label="site.value" border>{{ site.name }}</el-radio-button>
            </template>
          </el-radio-group>
        </el-form-item>
      </template>

      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" type="text" placeholder="客户名称,不要加地址或电话"></el-input>
      </el-form-item>

      <el-form-item label="姓名">
        <el-input v-model="form.contact_name" type="text" placeholder="联系人姓名"></el-input>
      </el-form-item>

      <el-form-item label="区域" prop="province">
        <el-cascader
          clearable
          filterable
          :props="{ expandTrigger: 'hover' }"
          :options="options"
          v-model="selectedOptions"
          @change="handleChange">
        </el-cascader>
      </el-form-item>

      <el-form-item label="地址">
        <el-input v-model="form.address" type="text" placeholder="地址详情">
          <el-button slot="append" icon="el-icon-location-information" @click="getAddress"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item label="主营" v-if="customer_businesses.length">
        <el-checkbox-group v-model="form.customer_business_ids">
          <template v-for="item in customer_businesses">
            <el-checkbox :label="item.id+''" :key="item.id">{{ item.name }}</el-checkbox>
          </template>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="类型" prop="customer_type_id" v-if="customer_types.length">
        <el-select v-model="form.customer_type_id" placeholder="请选择客户类型">
          <template v-for="item in customer_types">
            <el-option :label="item.name" :key="item.id" :value="item.id">{{ item.name }}</el-option>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="等级" prop="customer_level_id" v-if="customer_levels.length">
        <el-select v-model="form.customer_level_id" placeholder="请选择客户类型">
          <template v-for="item in customer_levels">
            <el-option :label="item.name" :key="item.id" :value="item.id">{{ item.name }}</el-option>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="复购" prop="repurchase">
        <el-radio-group v-model="form.repurchase">
          <el-radio :label="0">不可复购</el-radio>
          <el-radio :label="1">可复购</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="销售" prop="charge_staff_id" v-if="sellers.length">
        <el-select v-model="form.charge_staff_id" placeholder="请选择对应销售人员">
          <template v-for="item in sellers">
            <el-option :label="item.name" :key="item.id" :value="item.id">{{ item.name }}</el-option>
          </template>
        </el-select>
      </el-form-item>

      <div class="button-center">
        <el-form-item>
          <el-button type="primary" @click="commit('form')">修改</el-button>
          <el-button @click="reset('form')">重置</el-button>
        </el-form-item>
      </div>

    </el-form>
  </div>
</template>

<script>

import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import Customer from '../api/customer'
import UserApi from '../api/user'
import wx from 'weixin-js-sdk'
import { CONFIG } from '../config'

export default {
  name: 'Edit',
  created () {
    this.buildRules()
    this.getUserInfo()
    this.getCustomerBusinesses()
    this.getCustomerTypes()
    this.getSellers().then(() => this.defaultStaff())
    this.getJssdkConfig()
    this.getOriginTypes()
    this.getOriginSites()
    this.getCustomerLevels()
    this.getInfo()
  },
  data () {
    return {
      loading: false,
      form: {
        name: '',
        contact_name: '',
        province: '',
        city: '',
        district: '',
        address: '',
        origin_type: '',
        origin_words: '',
        origin_site: '',
        customer_business_ids: [],
        customer_type_id: '',
        customer_level_id: '',
        repurchase: 0,
        charge_staff_id: '',
        latitude: '',
        longitude: ''
      },
      info: {},
      customer_businesses: [],
      customer_types: [],
      customer_levels: [],
      originSites: [],
      originTypes: [],
      sellers: [],
      currentUser: null,
      phoneLoading: false,
      rules: {},

      options: regionDataPlus,
      selectedOptions: []
    }
  },
  watch: {
    customer_types () { this.buildRules() },
    customer_levels () { this.buildRules() },
    sellers () { this.buildRules() }
  },
  computed: {
    auth_user_id: {
      get: function () {
        return this.$store.getters.getUid
      },
      set: function (value) {
        this.form.user_id = value
      }
    }
  },
  methods: {
    buildRules () {
      const rules = {
        origin_type: [
          { required: true, message: '请选择来源', trigger: 'change' }
        ],
        name: [
          { required: true, message: '必须输入名称', trigger: 'blur' }
        ],
        repurchase: [
          { required: true, message: '请设置客户是否可复购', trigger: 'change' }
        ],
        province: [
          { required: true, message: '请选择所在区域', trigger: 'change' }
        ]
      }
      if (this.customer_types.length) {
        rules.customer_type_id = [{ required: true, message: '请选择客户类型', trigger: 'change' }]
      }
      if (this.customer_levels.length) {
        rules.customer_level_id = [{ required: true, message: '请选择客户等级', trigger: 'change' }]
      }
      if (this.sellers.length) {
        rules.charge_staff_id = [{ required: true, message: '请指定销售员', trigger: 'change' }]
      }
      this.rules = rules
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    getOriginTypes () {
      Customer.get_origin_types().then(res => {
        if (res.data.code === 1) {
          this.originTypes = res.data.data
        }
      })
    },
    getOriginSites () {
      Customer.get_origin_sites().then(res => {
        if (res.data.code === 1) {
          this.originSites = res.data.data
        }
      })
    },
    getJssdkConfig () {
      let data = {
        url: CONFIG.isIOS()
          ? (sessionStorage.getItem('wx_landing_url') || window.location.href.split('#')[0])
          : window.location.href.split('#')[0],
        api: ['openLocation', 'getLocation', 'shareAppMessage', 'selectEnterpriseContact']
      }
      Customer.get_jssdk_config(data).then(res => {
        if (res.data && res.data.code === 1 && res.data.data.status) {
          wx.config(res.data.data.data)
        }
      })
    },
    getUserInfo () {
      UserApi.getUserInfo().then(res => {
        if (res.data && res.data.code === 1) {
          this.currentUser = { ...res.data.data }
          this.defaultStaff()
        }
      })
    },
    getInfo () {
      this.loading = true
      let id = this.$route.params.id
      Customer.get_customer(id).then(res => {
        this.info = res.data.data
        this.form.name = this.info.name
        this.form.contact_name = this.info.contact_name
        this.form.id = this.info.id
        this.form.province = this.info.province
        this.form.city = this.info.city
        this.form.district = this.info.district
        this.form.address = this.info.address
        this.form.latitude = this.info.latitude
        this.form.longitude = this.info.longitude
        this.form.origin_type = this.info.origin_type
        this.form.origin_words = this.info.origin_words
        this.form.origin_site = this.info.origin_site
        this.form.customer_type_id = this.info.customer_type_id || ''
        this.form.customer_level_id = this.info.customer_level_id || ''
        this.form.repurchase = this.info.repurchase
        this.form.charge_staff_id = this.info.charge_staff_id
        if (this.info.customer_business_ids) {
          let str = this.info.customer_business_ids
          this.form.customer_business_ids = str.split(',')
        }

        // 当数据库中地区信息与客户端数据不一致时候，会发生错误,需要进行兼容操作
        try {
          let province = this.info.province && TextToCode[this.info.province] && TextToCode[this.info.province].code
          let _city = this.info.city
          if (this.info.city && this.info.city === this.info.province) {
            _city = '市辖区'
          }
          let city = this.info.city && TextToCode[this.info.province][_city] && TextToCode[this.info.province][_city].code
          let district = this.info.district && TextToCode[this.info.province][_city][this.info.district] && TextToCode[this.info.province][_city][this.info.district].code
          this.selectedOptions = [province, city, district]
        } catch (e) {
          throw new Error('客户所在地区错误，请重新选择')
        }
        this.loading = false
        this.defaultStaff()
      }).catch(res => {
        if (res.response) {
          this.$message.error('响应错误')
        } else {
          this.$message.error(res.message ? res.message : '客户信息解析错误')
          this.loading = false
        }
      })
    },
    handleChange () {
      this.form.province = CodeToText[this.selectedOptions[0]]
      this.form.city = CodeToText[this.selectedOptions[1]]
      this.form.district = CodeToText[this.selectedOptions[2]]
    },
    getCustomerBusinesses () {
      Customer.get_customer_business().then(res => {
        this.customer_businesses = res.data.data || []
      })
    },
    getCustomerTypes () {
      Customer.get_customer_type().then(res => {
        this.customer_types = res.data.data || []
      })
    },
    getCustomerLevels () {
      Customer.get_customer_levels().then(res => {
        this.customer_levels = res.data.data || []
      })
    },
    getSellers () {
      return Customer.get_salesmen().then(res => {
        this.sellers = res.data.data || []
      })
    },
    defaultStaff () {
      if (!this.currentUser || this.form.charge_staff_id) return
      if (!this.sellers.length || this.currentUser.group_id === 2) {
        this.form.charge_staff_id = this.currentUser.staff_id
      }
    },
    commit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          Customer.edit_customer(this.form).then(res => {
            if (res.data.code === 1) {
              this.$message.success('修改成功')
              this.$router.replace({ name: 'info', params: { id: this.info.id } })
            } else {
              this.$message.error(res.data.msg || '修改失败');
            }
          })
        } else {
          return false;
        }
      });
    },
    reset (form) {
      this.getInfo()
    },
    goBack () {
      this.$router.go(-1)
    },
    getAddress: function () {
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          this.loading = true

          this.form.latitude = res.latitude
          this.form.longitude = res.longitude
          Customer.get_map_address(res.latitude + ',' + res.longitude).then(res => {
            this.loading = false
            if (res.data && res.data.code === 1 && res.data.data.status === 0) {
              let result = res.data.data.result || null
              let objStr = JSON.stringify(result, null, 4);
              this.html = objStr.replace(/\n/g, '<br>').replace(/\s/g, ' ')
              this.form.address = result.formatted_addresses.recommend
              if (result.address_component) {
                let _comp = result.address_component
                let province = _comp.province &&
                  TextToCode[_comp.province].code
                let city = _comp.city &&
                  TextToCode[_comp.province][_comp.city].code
                let district = _comp.district &&
                  TextToCode[_comp.province][_comp.city][_comp.district].code
                this.selectedOptions = [province, city, district]
                this.handleChange()
              }
            } else {
              this.$message.error(res.data.msg || '获取地址信息失败')
            }
          }).catch(() => {
            this.loading = false
            this.$message.error('地图接口调用失败')
          })
        },
        fail: res => {
          let description = '';
          for (let i in res) {
            description += i + ' = ' + res[i] + '\n';
          }
          alert(description);
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-cascader-panel {
  .el-cascader-node {
    padding: 0 15px 0 5px;
  }

  .el-cascader-menu {
    min-width: 10px;
  }
}

.edit_page {
  margin: 0 8px;

  .page-header {
    position: relative;
    text-align: center;
    line-height: 50px;

    .el-button {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .title {
    text-align: center;
    font-size: 22px;
    line-height: 50px;
    color: #409EFF;
  }

  .el-cascader {
    width: 100%;
  }

  .el-input-group__append {
    padding: 0 10px;
  }

  .button-center {
    text-align: center;
  }

  .el-checkbox-group, .el-checkbox {
    line-height: 20px;
  }

  .el-select {
    width: 100%;
  }
}

</style>
